import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function inlineStyle({ $inline = false }: ButtonStyleProps) {
  if ($inline) {
    return css`
      display: inline;
      line-height: 1.6;
      margin-right: 0 !important;

      > * {
        display: inline;
      }
    `;
  }
}
